/**
 * Created by ShaunBetts on 10-Apr-16.
 */
'use strict';

import Vue from 'vue';
import Vuex from 'vuex';

export default function (localStoreModulesContext, localStoreModules, onAddModule) {
  Vue.use(Vuex);

  let modules = {};

  let initStateActions = [];

  let modulesContext = require.context('./modules/', true, /index.js$/);

  let addModule = (moduleName, {state, actions, getters, mutations}) => {
    modules[moduleName] = {namespaced: true, state, actions, getters, mutations};

    if(_.isFunction(onAddModule)){
      onAddModule(moduleName, modules[moduleName]);
    }

    if (actions.hasOwnProperty('initState')) {
      initStateActions.push(`${moduleName}/initState`);
    }
  };

  //Local Modules Passed In As Object
  _.forEach(localStoreModules, (module, moduleName) => {
    addModule(moduleName, module);
  });

  //Local Modules Passed In As Webpack Require Context
  let getModulesFromContext = (context) => {
    context.keys().forEach((module) => {
      addModule(module.substring(2, module.indexOf('/', 2)), context(module).default);
    });
  };

  getModulesFromContext(modulesContext);

  if (localStoreModulesContext) {
    getModulesFromContext(localStoreModulesContext);
  }

  // create the store
  let store = new Vuex.Store({
    strict: true,
    modules: modules
  });

  //call all initState actions
  initStateActions.map((action) => store.dispatch(action));

  return store;
};
